<template>
    <div class="d-flex" v-if="user">
        <div class="d-block" style="width: 380px;">
            <Card :bordered="false">
                <div class="d-flex justify-start">
                    <Button icon="ios-arrow-back" @click="onBack"/>
                    <h2 class="ml-md">基础信息</h2>
                    <span class="d-flex-item"/>
                    <div class="d-block">
                        <button class="btn btn-icons btn-primary" @click="onUser">
                            <img src="static/icon/editor-white@16px.png"/>
                        </button>
                        <button class="btn btn-icons btn-danger" v-if="false" @click="">
                            <img src="static/icon/delete-white@16px.png"/>
                        </button>
                    </div>
                </div>
                <br/>
                <div class="d-block" :style="{height: $common.content.height - 184 + 'px', lineHeight: 22 + 'px'}">
                    <ul style="list-style: none;">
                        <li>姓名：{{ user.name }}</li>
                        <li>性别：{{ user.sex ? ($common.sex.find(it => it.value === user.sex).text) : '' }}</li>
                        <li>出生日期：{{ $moment(user.birthday).format('YYYY年MM月DD日') }}</li>
                        <!-- <li>月龄：{{ user.month}}月</li> -->
                        <li>用户ID：{{ user.hospitalId }}</li>
                        <li>身份证号：{{ user.idCard }}</li>
                        <li>联系电话：{{ user.phone }}</li>
                        <li>地址：{{ user.regionName ? user.regionName.replace(/,/g, '') : '' }}{{ user.address }}</li>
                    </ul>
                    <div class="d-block mt-sm" v-if="user.parents && user.parents.length > 0 && user.parents[0].name">
                        <h3>父亲信息：</h3>
                        <ul style="list-style: none;">
                            <li>姓名：{{ user.parents[0].name }}</li>
                            <li>联系电话：{{ user.parents[0].phone }}</li>
                            <li>出生日期：{{ $moment(user.parents[0].birthday).format('YYYY-MM-DD') }}</li>
                            <li>文化程度：{{ $common.education.find(it => it.value === user.parents[0].education).name }}</li>
                            <li>职业：{{ $common.occupation.find(it => it.value === user.parents[0].occupation).name }}</li>
                        </ul>
                    </div>
                    <div class="d-block mt-sm" v-if="user.parents && user.parents.length > 1 && user.parents[1].name">
                        <h3>母亲信息：</h3>
                        <ul style="list-style: none;">
                            <li>姓名：{{ user.parents[1].name }}</li>
                            <li>联系电话：{{ user.parents[1].phone }}</li>
                            <li>出生日期：{{ $moment(user.parents[1].birthday).format('YYYY-MM-DD') }}</li>
                            <li>文化程度：{{ $common.education.find(it => it.value === user.parents[1].education).name }}</li>
                            <li>职业：{{ $common.occupation.find(it => it.value === user.parents[1].occupation).name }}</li>
                        </ul>
                    </div>
                </div>
            </Card>
        </div>
        <div class="d-flex-item ml-md">
            <Card :bordered="false">
                <div class="d-flex justify-center">
                    <a class="tk-btns" :class="it.class" v-for="(it, i) in taskType" :key="i" @click="addTask(it, i)">
                        <span>
                            <img :src="'static/img/' + it.img"/>
                        </span>
                        <h4 class="c-black">{{ it.name }}</h4>
                    </a>
                </div>
            </Card>
            <br/>
            <Card :bordered="false">
                <div class="d-flex justify-center">
                    <a class="tk-type" :class="{act: type === 1}" @click="onType(1)">测评记录</a>
                    <a class="tk-type" :class="{act: type === 4}" @click="onType(4)">训练记录</a>
                    <!-- <a class="tk-type" :class="{act: type === 2}" @click="onType(2)">发育档案</a> -->
                    <!-- <a class="tk-type" :class="{act: type === 3}" @click="onType(3)">实时脑电</a> -->
                    <a class="tk-print" v-if="type === 2" @click="onPrint('print-main')"><img class="mr-xs" src="static/icon/print-white@16px.png">打印</a>
                </div>
                <br/>
                <div class="d-block scrollbar" v-if="type === 1" :style="{height: $common.content.height - 310 + 'px'}">
                    <Table :columns="examColumns" :data="examData">
                        <template slot="reportTime" slot-scope="{row, index}">
                            <span>{{ row.reportTime ? $moment(row.reportTime).format('YYYY-MM-DD HH:mm:ss') : '' }}</span>
                        </template>
                        <template slot="action" slot-scope="{row, index}">
                            <div class="d-block al-right">
                                <button title="下载：原始脑电" class="btn btn-sm btn-icons btn-primary" v-if="row.brainFilePath" @click="onExamData(row, index, 1)">
                                    <img src="static/icon/download-white@16px.png"/>
                                </button>
                                <button title="查看/打印：筛查报告" class="btn btn-sm btn-icons btn-warning" v-if="row.reportPath" @click="onExamData(row, index, 2)">
                                    <img src="static/icon/print-white@16px.png"/>
                                </button>
                            </div>
                        </template>
                    </Table>
                    <div class="mask" v-html="mask" v-if="examData.length === 0"/>
                </div>
                <div class="d-block scrollbar" v-if="type === 2" :style="{height: $common.content.height - 310 + 'px'}">
                    <div class="d-block" style="width: 1016px; margin: auto;">
                        <div class="print-root">
                            <div class="d-block" ref="print-main">
                                <fayudangan :user="user" v-if="false"/>
                                <jichuxinxi :user="user"/>
                                <chushai :user="user" :data="item.testResult" v-for="(item, index) in scaleRecord" :key="index" v-if="item.scale === 1"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-block scrollbar" v-if="type === 3" :style="{height: $common.content.height - 310 + 'px'}">
                    <div class="d-block">
                        <Row :gutter="16" justify="center" align="middle">
                            <Col span="9">
                                <div id="leftNaoboCharts" class="d-block" style="height: 250px;"/>
                            </Col>
                            <Col span="6">
                                <div class="d-block" v-if="leftCerebrum !== ''">
                                    <div style="position: relative;">
                                        <img style="max-width: 80%;" src="../../assets/img/cerebrum.png">
                                        <div class="cerebrum">
                                            <img class="cerebrum-img-left" :style="{filter: 'drop-shadow(400px 0px ' + leftCerebrum + ')' }" src="../../assets/img/left.png">
                                        </div>
                                        <div class="cerebrum">
                                            <img class="cerebrum-img-rigth" :style="{filter: 'drop-shadow(-400px 0px' + rigthCerebrum + ')' }" src="../../assets/img/right.png">
                                        </div>
                                    </div>
                                    <div class="colour-gamut">
                                        <div>50</div>
                                        <div class="colour-gamut-bar"></div>
                                        <div>-50</div>
                                    </div>
                                </div>
                            </Col>
                            <Col span="9">
                                <div id="rightNaoboCharts" class="d-block" style="height: 250px;"/>
                            </Col>
                        </Row>
                        <br />
                        <Row :gutter="16" justify="center" align="middle">
                            <Col span="6">
                                <div class="d-block" id="naobo_zhishi_qingxu" style="height: 300px;"/>
                            </Col>
                            <Col span="6">
                                <div class="d-block" id="naobo_zhishi_renzhi" style="height: 300px;" />
                            </Col>
                            <Col span="6">
                                <div class="d-block" id="naobo_zhishi_zhuyi" style="height: 300px;" />
                            </Col>
                            <Col span="6">
                                <div class="d-block" v-if="powerSpectrumDatas.length === 2">
                                    <Table size="large" :columns="powerSpectrumColumns" :data="powerSpectrumDatas"/>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div class="mask" v-html="mask" v-if="!socket"/>
                </div>

                <div class="d-block scrollbar" v-if="type === 4" :style="{height: $common.content.height - 310 + 'px'}">
                    <Table :columns="trainColumns" :data="trains">
                        <template slot="beginTime" slot-scope="{row, index}">
                            <span>{{ row.beginTime ? $moment(row.beginTime).format('YYYY-MM-DD HH:mm:ss') : '' }}</span>
                        </template>
                        <template slot="endTime" slot-scope="{row, index}">
                            <span>{{ row.endTime ? $moment(row.endTime).format('YYYY-MM-DD HH:mm:ss') : '' }}</span>
                        </template>                        
                        <template slot="action" slot-scope="{row, index}">
                            <div class="d-block al-right">                                
                                <button title="查看/打印" class="btn btn-sm btn-icons btn-warning" @click="printTrain(row, index)">
                                    <img src="static/icon/print-white@16px.png"/>
                                </button>
                            </div>
                        </template>
                    </Table>
                    <div class="mask" v-html="mask" v-if="trains.length === 0"/>
                </div>                
            </Card>
        </div>
        
        <Modal width="440" title="测评方案" v-model="gatherConfig.show" @on-cancel="canGatherConfig">
            <div class="d-block" v-if="gatherConfig.show">
                <!-- 
                <RadioGroup class="d-block" size="large" vertical v-model="gatherConfig.gatherType">
                    <div class="d-block" style="padding: 6px 12px; border-radius: 4px; background: #f7f8fa;">
                        <Radio :label="1" :disabled="gatherConfig.scale === 5 ? true : false">自动方案</Radio>
                    </div>
                    <div class="d-block mt-xs" style="padding: 6px 12px; border-radius: 4px; background: #f7f8fa;">
                        <Radio :label="2" :disabled="gatherConfig.scale === 5 ? true : false">定制方案</Radio>
                    </div>
                </RadioGroup>
                -->
                <div class="d-block" style="padding: 8px 8px 8px 32px; margin-top: -4px; border-radius: 4px;" v-if="gatherConfig.gatherType === 2">
                    <!-- 
                    <p class="d-flex justify-start">
                        <b class="c-error mr-ns">*</b>
                        <span class="width-80">脑电采集</span>
                        <i-switch v-model="gatherConfig.gatherEeg" @on-change=""/>
                    </p> 
                    -->
                    <div class="d-block" v-if="gatherConfig.scale === 1">
                        <p class="d-flex justify-start mt-md">
                            <b class="c-error mr-ns">*</b>
                            <!-- 儿心量表| -->
                            <span class="width-180">行为问题预警征象筛查表</span>
                            <i-switch v-model="gatherConfig.gatherScale" @on-change=""/>
                        </p>
                    </div>
                    <div class="d-block" v-if="gatherConfig.scale === 2">
                        <p class="d-flex justify-start mt-xs">
                            <b class="c-error mr-ns">*</b>
                            <!--儿心量表||-->
                            <span class="width-100">行为评估量表</span>
                            <i-switch v-model="gatherConfig.gatherScale" @on-change=""/>
                        </p>
                        <p class="d-flex justify-start mt-xs" v-if="gatherConfig.gatherScale">
                            <b class="c-error mr-ns">*</b>
                            <span class="width-80">实测月龄</span>
                            <Select placeholder="请选择月龄" style="width: 124px;" v-model="gatherConfig.gatherMonth">
                                <Option :value="it" v-for="(it, i) in 84" :key="i">{{ it }}月</Option>
                            </Select>
                        </p>
                        <p class="d-flex justify-start mt-xs">
                            <b class="c-error mr-ns">*</b>
                            <span class="width-80">其他量表</span>
                            <RadioGroup v-model="gatherConfig.gatherOtherScale" vertical>
                                <!--M-Chat-->
                                <Radio label="M-Chat">自闭症谱系障碍风险量表（M-Chat）</Radio>
                                <!--ABC-->
                                <Radio label="ABC">自闭症行为量表（ABC）</Radio>
                                <Radio label="WU">无</Radio>
                            </RadioGroup>
                        </p>
                    </div>
                    <div class="d-block" v-if="gatherConfig.scale === 3 || gatherConfig.scale === 4">
                        <p class="d-flex justify-start mt-md">
                            <b class="c-error mr-ns">*</b>
                            <!--CARS量表-->
                            <span class="width-180">自闭症诊断量表（CARS）</span>
                            <i-switch v-model="gatherConfig.gatherScale" @on-change=""/>
                        </p>
                    </div>
                    <div class="d-block" v-if="gatherConfig.scale === 5">
                        <p class="">
                            <b class="c-error mr-ns">*</b>
                            <span class="width-80">记忆障碍自评表（AD8）</span>
                            <i-switch v-model="gatherConfig.gatherScale" @on-change=""/>
                        </p>
                    </div>
                    <div class="d-block" v-if="gatherConfig.scale === 6">
                        <p class="">
                            <b class="c-error mr-ns">*</b>
                            <span class="width-80">语言能力量表</span>
                            <i-switch v-model="gatherConfig.gatherScale" @on-change=""/>
                        </p>
                    </div>
                    <div class="d-block" v-if="gatherConfig.scale === 7">
                        <p class="">
                            <b class="c-error mr-ns">*</b>
                            <span class="width-80">注意力缺陷评定量表</span>
                            <i-switch v-model="gatherConfig.gatherScale" @on-change=""/>
                        </p>
                    </div>                    
                </div>
            </div>
            <div slot="footer">
                <Button type="text" @click="canGatherConfig">取消</Button>
                <Button type="primary" @click="comGatherConfig">确定</Button>
            </div>
        </Modal>

        <Modal width="848" :footer-hide="true" title="选择设备" v-model="deviceModal" @on-cancel="celDevice(true)">
            <div class="d-block scrollbar" v-if="deviceModal" style="overflow-x: hidden !important; max-height: 700px;">
                <Row :gutter="16">
                    <Col span="12" v-for="(it, i) in deviceArray" :key="i">
                        <a :class="i + 1 === deviceArray.length ? '' : 'mb-md'" class="item-device" @click="onDevice(it, i)">
                            <h1>{{ i + 1 }}</h1>
                            <h2>{{ it.name }}</h2>
                        </a>
                    </Col>
                </Row>
            </div>
        </Modal>

        <Modal width="1016" title="训练报告" v-model="trainModal">
            <div class="print-root" :style="{height: $common.content.height - 170 + 'px'}">
                <div class="d-block" ref="train-print-main">
                    <TrainResult :user="user" :data="train"/>
                </div>
            </div>
            <div slot="footer" class="align-center">
                <Button class="width-100" type="primary" @click="onPrint('train-print-main')">打印</Button>
            </div>
        </Modal>
    </div>
</template>

<style scoped>
    .mask{
        display: flex;
        display: -webkit-flex;
        flex-direction: column;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 10;
        background: #fff;
        justify-content: center;
        align-items: center;
    }
    .tk-btns{
        display: flex;
        display: -webkit-flex;
        flex-direction: column;
        position: relative;
        justify-content: center;
        align-items: center;
    }
    .tk-btns > span{
        display: flex;
        display: -webkit-flex;
        position: relative;
        width: 48px;
        height: 48px;
        margin: 0 24px;
        border-radius: 50%;
        background: #409eff;
        justify-content: center;
        align-items: center;
    }
    .tk-btns > span > img{width: 24px;}
    .tk-btns.ing > span{background: #e6a23c;}
    .tk-btns.end > span{background: #67c23a;}

    .tk-type{
        display: block;
        position: relative;
        padding: 0 30px;
        margin: 0 8px;
        line-height: 40px;
        font-weight: bold;
        color: #333;
        border-radius: 40px;
    }
    .tk-type:hover{background: #eee;}
    .tk-type.act{color: #fff; background: #409eff;}

    .tk-print{
        display: flex;
        display: -webkit-flex;
        position: absolute;
        top: 0;
        right: 0;
        padding: 0 30px;
        line-height: 40px;
        font-weight: bold;
        color: #fff;
        background: #e6a23c;
        border-radius: 40px;
        justify-content: flex-start;
        align-items: center;
    }


    .cerebrum {
        position: absolute;
        max-width: 80%;
        overflow: hidden;
        top: 0px;
    }

    .cerebrum > img {
        max-width: 100%;
        max-height: 100%;
    }

    .cerebrum-img-left {
        transform: translateX(-400px);
    }

    .cerebrum-img-rigth {
        transform: translateX(400px);
    }

    .colour-gamut {
        display: flex;
        justify-content: space-between;
        height: 50px;
        align-items: center;
        font-size: 18px;
    }

    .colour-gamut-bar {
        width: 90%;
        height: 70%;
        background: linear-gradient(to right, yellow, red, blue, green);
    }
</style>

<script type="text/javascript">
    import PrintJS from 'print-js';

    import fayudangan from "../prints/fayudangan";
    import jichuxinxi from "../prints/jichuxinxi";
    import chushai from "../prints/chushai";
    import fushai from "../prints/fushai";
    import zhenduan from "../prints/zhenduan";
    import TrainResult from "../prints/TrainResult";

    export default {
        components: {
            fayudangan, jichuxinxi, chushai, fushai, zhenduan,TrainResult
        },
        data () {
            return {
                uid: Number(this.$route.query.uid),
                user: {}, // 当前用户

                mask: '<img src="static/mask.png" style="opacity: .1;"/><br/><h1 class="c-gray font-normal">暂无数据</h1>',

                type: 1,

                task: null, // 当前任务
                taskType: [
                    {scale: 1, class: '', name: '认知测评一', img: 'exam-chushai.png'},
                    {scale: 2, class: '', name: '认知测评二', img: 'exam-fushai.png'},
                    {scale: 3, class: '', name: '认知测评三', img: 'exam-zhenduan.png'},
                    {scale: 4, class: '', name: '认知测评四', img: 'exam-fuzhen.png'},
                    {scale: 5, class: '', name: '认知测评五', img: 'exam-renzhipinggu.png'},                    
                    {scale: 6, class: '', name: '认知测评六', img: 'exam-renzhipinggu.png'},                    
                    {scale: 7, class: '', name: '认知测评七', img: 'exam-renzhipinggu.png'},                    
                    // {scale: 1, class: '', name: '初筛', img: 'exam-chushai.png'},
                    // {scale: 2, class: '', name: '复筛', img: 'exam-fushai.png'},
                    // {scale: 3, class: '', name: '诊断', img: 'exam-zhenduan.png'},
                    // {scale: 4, class: '', name: '复诊', img: 'exam-fuzhen.png'},
                    // {scale: 5, class: '', name: '认知评估', img: 'exam-renzhipinggu.png'},
                ],

                gatherConfig: {}, // 筛查配置

                examColumns: [
                    {
                        title: '任务名称',
                        key: 'name',
                    },
                    {
                        title: '报告日期',
                        slot: 'reportTime',
                    },
                    {
                        title: '操作',
                        slot: 'action',
                        align: 'center',
                        width: 106,
                    }
                ],
                examData: [],

                trainColumns: [
                    {
                        title: '开始时间',
                        slot: 'beginTime',
                    },
                    {
                        title: '结束时间',
                        slot: 'endTime',
                    },
                    {
                        title: '得分',
                        key: "score",
                    },                    
                    {
                        title: '操作',
                        slot: 'action',
                        align: 'center',
                        width: 106,
                    }
                ],                
                trains:[],
                trainModal: false,
                train: {},

                deviceModal: false,
                deviceArray: [],
                deviceActive: {},

                scaleRecord: [], // 量表测评记录

                socket: null,

                leftNaoboCharts: null, // 左脑图
                rightNaoboCharts: null, // 右脑图
                leftCerebrum: "", // 左脑平均值
                rigthCerebrum: "", // 右脑平均值
                gaugePtion: {
                    series: [
                        {
                            type: 'gauge',
                            radius: "70%",
                            axisLine: { // 轴线（最外层圆弧线）
                                lineStyle: {
                                    width: 3,
                                    color: [
                                        [1, '#FFFFFF']
                                    ]
                                }
                            },
                            splitLine: { // 分割线
                                lineStyle: {
                                    color: '#FFFFFF'
                                }
                            },
                            axisLabel: { // 分割线刻度
                                show: true,
                                color: "#FFFFFF"
                            },
                            axisTick: { // 刻度线
                                lineStyle: {
                                    color: "#FFFFFF"
                                }
                            },
                            data: [
                                {
                                    name: '',
                                    value: 0,
                                    title: {
                                        color: "#FFFFFF"
                                    },
                                    detail: {
                                        color: "#FFFFFF"
                                    },
                                    itemStyle: {
                                        color: "#FFFFFF"
                                    }
                                }
                            ]
                        },
                        {
                            name: 'Access From',
                            type: 'pie',
                            "z": -10,
                            animation: false,
                            "label": {
                                "normal": {
                                    "show": false,
                                    "position": 'center'
                                },
                                "emphasis": {
                                    "show": false
                                }
                            },
                            "labelLine": {
                                "normal": {
                                    "show": false
                                }
                            },
                            data: [
                                {
                                    value: 0,
                                    name: '背景图',
                                    itemStyle: {
                                        normal: {
                                            color: ""
                                        }
                                    }
                                }
                            ]
                        }
                    ]
                },
                naobo_zhishi_qingxu: null, // 情绪
                naobo_zhishi_renzhi: null, // 认知
                naobo_zhishi_zhuyi: null, // 注意
                powerSpectrumColumns: [
                    {
                        title: '通道',
                        align: 'center',
                        key: 'name'
                    },
                    {
                        title: 'DELTA（δ）',
                        align: 'center',
                        key: 'delta'
                    },
                    {
                        title: 'THETA（θ）',
                        align: 'center',
                        key: 'theta'
                    },
                    {
                        title: 'ALPHA（α）',
                        align: 'center',
                        key: 'alpha'
                    },
                    {
                        title: 'BETA（β）',
                        align: 'center',
                        key: 'beta'
                    }
                ],
                powerSpectrumDatas: [],
            }
        },
        async beforeDestroy() {
            await this.$bus.off('initChangeUserSuccess');
            await this.$bus.off('socket');
        },
        async created() {
            this.user = await this.$common.getUser(this.uid);
            console.log('this.user---------->', this.user);

            await this.onType(this.type);
        },
        async mounted() {
            await this.$bus.on('initChangeUserSuccess', async (data) => {
                console.log('this.initChangeUserSuccess---------->', data);
                if (!data) return;
                this.user = await this.$common.getUser(this.uid);
            });

            await this.$bus.on('socket', async (data, socket) => {
                console.log('this.socket---------->', data, socket);
                if (!data || !socket) return;
                this.socket = socket;

                // 实时测评
                if (socket.dataType === 'timeDomain') {
                    if (socket.data.topicId === -100 || socket.data.topicId === 0){
                        await this.__leftNnaoboCharts(socket.data);
                        await this.__rightNnaoboCharts(socket.data);
                        await this.__showCerebrum(socket.data);
                        await this.__naobo_zhishi_qingxu(socket.data);
                        await this.__naobo_zhishi_renzhi(socket.data);
                        await this.__naobo_zhishi_zhuyi(socket.data);
                        await this.__showPowerSpectrum(socket.data);
                    } else {
                        await this.__clearAllCharts();
                    }
                }

                // 测评结束
                if (socket.dataType === 'over') {
                    this.type = 1;
                    this.task = null;
                    this.taskType.forEach(e => e.class = '');
                    this.socket = null;
                    await this.__clearAllCharts();
                    await this.getExamData();
                }
            });
        },
        methods: {
            async onBack(){
                if (this.task){
                    await this.endTask(false, false);
                    await this.delTask(true);
                }
                return this.$router.go(-1);
            },

            async onUser(){
                return await this.$bus.emit('initChangeUser', true, this.user, 2);
            },

            async onType(type){
                this.type = type;
                if (type === 1){
                    await this.getExamData();
                }
                if (type === 2){
                    await this.getScaleRecord();
                }
                if (type === 4) {
                    await this.getTrainResults();                    
                }
            },

            async getExamData() {
                let res = await this.$api.getHttp('task/user/tasks?testUserId=' + this.uid);
                console.log('this.getExamData---------->', res);
                if (res.data.code !== 0) {
                    return await this.$common.alertModel('error', res.data.msg);
                }
                this.examData = this.$common.sorting(res.data.data, 'id', 'down');
            },

            async getScaleRecord() {
                let res = await this.$api.getHttp('task/scaleRecord/' + this.uid);
                console.log('this.getScaleRecord---------->', res);
                if (res.data.code !== 0) {
                    return await this.$common.alertModel('error', res.data.msg);
                }
                let array = res.data.data;
                for (let i = 0; i < array.length; i++) {
                    let it = array[i];
                    let title = '0～6岁儿童心理行为发育初筛记录表 ';
                    if (it.testResult && it.testResult !== 'None'){
                        it.testResult = JSON.parse(it.testResult);
                    }
                    if (it.scale === 1){
                        if (this.user.month <= 12){
                            title += '婴儿期（0～1岁）';
                        }
                        if (this.user.month > 12 && this.user.month <= 36){
                            title += '幼儿期（1～3岁）';
                        }
                        if (this.user.month > 36){
                            title += '学龄前期（4～6岁）';
                        }
                    }
                    it.testResult.title = title;
                }
                this.scaleRecord = this.$common.sorting(array, 'scale', 'down');
            },

            async addTask(it, i){
                console.log('this.addTask---------->', it, i);
                if (this.task){
                    await this.endTask(false, false);
                    await this.delTask(true);
                    return;
                }
                let gatherMonth = (this.user.month % 1 !== 0) ? Math.trunc(this.user.month) : this.user.month;                
                return this.gatherConfig = {
                    show: true,
                    scale: it.scale,
                    gatherType: 2,
                    gatherEeg: false,                    
                    gatherScale:true,
                    gatherMonth: gatherMonth
                };
            },
            async canGatherConfig(){
                return this.gatherConfig = {};
            },
            async comGatherConfig(){
                // debugger
                console.log('this.comGatherConfig---------->', this.gatherConfig);
                let conf = this.gatherConfig;
                if (conf.scale === 1 && conf.gatherType === 2){
                    if (!conf.gatherEeg && !conf.gatherScale){
                        // return await this.$common.alertModel('warning', '脑电采集 & 量表必须选择其中一个');
                        return await this.$common.alertModel('warning', '量表必须选择');
                    }
                }
                if (conf.scale === 2 && conf.gatherType === 1){
                    conf.gatherOtherScale = 'WU';
                }
                if (conf.scale === 2 && conf.gatherType === 2){
                    if (!conf.gatherEeg && !conf.gatherScale && !conf.gatherOtherScale){
                        // return await this.$common.alertModel('warning', '脑电采集，儿心量表||，其他量表必须选择其中一个');
                        return await this.$common.alertModel('warning', '儿心量表||，其他量表必须选择其中一个');
                    }
                    if (!conf.gatherEeg && !conf.gatherScale && conf.gatherOtherScale === 'WU'){
                        // return await this.$common.alertModel('warning', '未选择（脑电采集或儿心量表||）的情况下其他量表不能选择无');
                        return await this.$common.alertModel('warning', '未选择儿心量表||的情况下其他量表不能选择无');
                    }
                }
                const scales = [3, 4, 5, 6, 7]
                if (scales.includes(conf.scale) && conf.gatherType === 2){
                    if (!conf.gatherEeg && !conf.gatherScale){
                        // return await this.$common.alertModel('warning', '脑电采集 & 量表必须选择其中一个');
                        return await this.$common.alertModel('warning', '量表必须选择');
                    }
                }                
                let assessConfig = {
                    gatherType: conf.gatherType, // 采集类型 1-自动方案（默认） 2-定制方案
                    gatherEeg: conf.gatherType === 1 ? true : (conf.gatherEeg || false), // 是否采集脑电
                    gatherScale: conf.gatherType === 1 ? true : (conf.gatherScale || false), // 是否采集量表
                    gatherMonth: conf.gatherMonth || '', // 实测月龄 - 仅 scale = 2 有效
                    gatherOtherScale: conf.gatherOtherScale || '', // 采集其他量表 - 仅 scale = 2 有效
                };

                let it = this.taskType.find(it => it.scale === conf.scale);

                if (this.task && this.task.status === 1){
                    if (!await this.$common.confirmModel('是否结束 <b class="c-primary">' + this.user.name + '</b> 的 <b class="c-error">' + it.name + '</b> 测评任务')) return;
                    await this.endTask(false, false);
                    await this.delTask(true);
                    return;
                }

                if (!await this.$common.confirmModel('确认为 <b class="c-primary">' + this.user.name + '</b> 创建 <b class="c-error">' + it.name + '</b> 测评任务')) return;

                let data = {
                    scale: it.scale, // 应用量表
                    taskName: this.user.name + '-' + it.name + '-' + this.$moment(new Date().getTime()).format('YYYY-MM-DD HH:mm:ss'), // 任务名称
                    beginTime: new Date().getTime(), // 开始时间
                    endTime: new Date().getTime(), // 结束时间
                    testUserIds: [this.user.id].toString(), // 测评用户id
                    assessConfig: assessConfig,
                };
                let res = await this.$api.postHttp('task/add', data);
                console.log('this.addTask---------->', res);
                if (res.data.code !== 0) {
                    return await this.$common.alertModel('error', res.data.msg);
                }
                // this.$Message.success(res.data.msg);
                this.gatherConfig = {};
                this.task = res.data.data;
                this.task.status = 1;

                // await this.$socket.init({uuid: this.$store.state.account.deviceCode}); // 链接socket
                await this.$socket.init({uuid: this.$store.state.deviceUuid}); // 链接socket

                await this.getDevice(true);
                await this.$forceUpdate();
            },

            async delTask(del){
                debugger
                if (!del) return;
                let res = await this.$api.deleteHttp('task/delete?id=' + this.task.id);
                if (res.data.code !== 0){
                    return await this.$common.alertModel('error', res.data.msg);
                }
                // this.$Message.success(res.data.msg);

                this.task = null;
                this.taskType.forEach(e => {
                    e.class = '';
                    if (e.scale === 1){
                        e.img = 'exam-chushai.png';
                    }
                    if (e.scale === 2){
                        e.img = 'exam-fushai.png';
                    }
                    if (e.scale === 3){
                        e.img = 'exam-zhenduan.png';
                    }
                    if (e.scale === 4){
                        e.img = 'exam-fuzhen.png';
                    }
                });

                this.type = 1;

                await this.getExamData();
            },
            async runTask(it, i){
                debugger
                console.log('this.runTask---------->', it, i);
                let res = await this.$api.putHttp('task/enable', {
                    taskId: this.task.id, // 任务id
                    deviceId: it.id, // 平板id
                    testUserId: this.user.id, // 用户id
                });
                console.log('this.runTask---------->', res);
                if (res.data.code !== 0) {
                    return await this.$common.alertModel('error', res.data.msg);
                }
                this.$Message.success(res.data.msg);
                if (res.data.code === 0) {
                    this.type = 3;
                    this.task.status = 1;
                    this.taskType.forEach(e => {
                        if (e.scale === this.task.scale){
                            e.class = 'ing';
                            e.img = 'exam-tingzhi.png';
                        }
                    });
                    await this.celDevice(false);
                }
                if (res.data.code === 1) {
                    if (!await this.$common.confirmModel(res.data.msg, {okText: '结束测评'})) return;
                    return await this.endTask(true, true);
                }
            },
            async endTask(getDevice, tips){
                let res = await this.$api.putHttp('task/reject', {
                    taskId: this.task.id, // 任务id
                    deviceId: this.deviceActive.id, // 平板id
                    testUserId: this.user.id, // 用户id
                });
                console.log('this.userReject---------->', res);
                if (res.data.code !== 0) {
                    return await this.$common.alertModel('error', res.data.msg);
                }
                await this.__clearAllCharts();
                if (tips){
                    this.$Message.success(res.data.msg);
                }
                if (getDevice){
                    await this.getDevice(getDevice);
                }
            },

            async getDevice(){
                let res = await this.$api.getHttp('device/own/device?type=2');
                console.log('this.getDevice---------->', res);
                if (res.data.code !== 0) {
                    return this.$Message.error(res.data.msg);
                }
                if (res.data.data.length === 0) {
                    return await this.$common.alertModel('warning', '未查询到可用设备');
                }
                this.deviceModal = true;
                this.deviceArray = res.data.data;
                debugger
            },
            async celDevice(delTask) {
                if (!delTask){
                    this.deviceModal = false;
                    this.deviceArray = [];
                    return;
                }
                await this.delTask(delTask);
            },
            async onDevice(it, i) {
                console.log('this.onDevice---------->', it, i);
                this.deviceActive = it;
                // if (it.used === 0){
                //     return await this.$common.alertModel('warning', '设备不在线');
                // }
                if (it.used === 1) {
                    if (!await this.$common.confirmModel('设备使用中', {okText: '结束测评'})) return;
                    return await this.endTask(true, true);
                }
                await this.runTask(it, i);
            },

            async onExamData(data, index, kind) {
                console.log('this.onExamData---------->', data, index, kind);
                if (kind === 1){
                    if (!data.brainFilePath || data.brainFilePath === ''){
                        return await this.$common.alertModel('error', '本次筛查暂无原始脑电');
                    }
                    return await this.$common.download(data, 'brainFilePath');
                }
                if (kind === 2){
                    if (!data.reportPath || data.reportPath === ''){
                        return await this.$common.alertModel('error', '本次筛查未生成报告');
                    }
                    return window.open(this.$api.resHttp().download + data.reportPath, '_blank');
                }
            },

            async getTrainResults(){
                let res = await this.$api.getHttp('exercise/list/' + this.uid);
                if (res.data.code !== 0) {
                    return await this.$common.alertModel('error', res.data.msg);
                }
                this.trains = res.data.data;
            },

            async printTrain(data, index) {
                this.train = data;
                console.log('训练数据：train=', this.train);
                this.trainModal = true;
            },

            async onPrint(elementRef){
                // let data = this.$store.state.printFormData;
                // if (data.referralStatus === 1 && data.referral === ''){
                //     return await this.$common.alertModel('warning', '上转接诊医疗机构名称不能为空');
                // }
                return await PrintJS({
                    printable: this.$refs[elementRef],
                    type: 'html',
                    maxWidth: '1000',
                    honorColor: true, // 是否彩色打印
                    style: '@page{size: 210mm 297mm; margin: 0; padding: 0;} body{margin: 0; padding: 0;}',
                    scanStyles: true,
                    css: '', // 如 ../style.css
                    targetStyles: ['*'], // *代表应用所有样式，默认值为null，如果不设置，打印窗口则会忽略所有样式
                    font_size: '999', // 解决字体大小问题
                });
            },


            // 清除图表
            async __clearAllCharts(){
                this.socket = null;
                this.leftNaoboCharts = null;
                this.rightNaoboCharts = null;
                this.leftCerebrum = '';
                this.rigthCerebrum = '';
                this.naobo_zhishi_qingxu = null; // 情绪
                this.naobo_zhishi_renzhi = null; // 认知
                this.naobo_zhishi_zhuyi = null; // 注意
                this.powerSpectrumDatas = [];
            },

            // 左脑
            async __leftNnaoboCharts(data) {
                if (!data) return;
                if (!this.leftNaoboCharts) {
                    this.leftNaoboCharts = this.$echarts.init(document.getElementById('leftNaoboCharts'));
                }

                let count = data.channel_raw_1.length;
                let xAxis = [];
                for (let i = 0; i < count; i++) {
                    xAxis.push(i);
                }

                let leftData = [];
                for (let i = 0; i < data.channel_raw_1.length; i++) {
                    leftData.push(data.channel_raw_1[i]);
                    if (leftData[i] > 200) {
                        leftData[i] = 200;
                    }
                    if (leftData[i] < -200) {
                        leftData[i] = -200;
                    }
                }

                let option = {
                    title: {
                        text: '脑波时域图（左脑）',
                        x: 'center',
                        y: 'top',
                        textAlign: 'center',
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true,
                    },
                    xAxis: {
                        type: 'category',
                        data: xAxis,
                        interval: 64, // 步长
                        min: 0, // 起始
                        max: 256, // 终止
                    },
                    yAxis: {
                        type: 'value',
                        min: -200,
                        max: 200,
                    },
                    series: [
                        {
                            name: '左脑',
                            type: 'line',
                            smooth: true,
                            symbol: 'none',
                            data: leftData,
                            itemStyle: {
                                normal: {
                                    color: '#f8ca34', // 折线点的颜色
                                    lineStyle: {
                                        color: '#f8ca34' // 折线颜色
                                    }
                                }
                            },
                        },
                    ]
                };

                this.leftNaoboCharts.setOption(option);
                window.addEventListener("resize", () => {
                    this.leftNaoboCharts.resize();
                });
            },

            // 右脑
            async __rightNnaoboCharts(data) {
                if (!data) return;
                if (!this.rightNaoboCharts) {
                    this.rightNaoboCharts = this.$echarts.init(document.getElementById('rightNaoboCharts'));
                }
                const count = data.channel_raw_2.length;
                const xAxis = [];
                for (let i = 0; i < count; i++) {
                    xAxis.push(i);
                }

                let rightData = [];
                for (let i = 0; i < data.channel_raw_2.length; i++) {
                    rightData.push(data.channel_raw_2[i]);
                    if (rightData[i] > 200) {
                        rightData[i] = 200;
                    }
                    if (rightData[i] < -200) {
                        rightData[i] = -200;
                    }
                }
                let option = {
                    title: {
                        text: '脑波时域图（右脑）',
                        x: 'center',
                        y: 'top',
                        textAlign: 'center',
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true,
                    },
                    xAxis: {
                        type: 'category',
                        data: xAxis,
                        interval: 64, // 步长
                        min: 0, // 起始
                        max: 256 // 终止
                    },
                    yAxis: {
                        type: 'value',
                        min: -200,
                        max: 200
                    },
                    series: [
                        {
                            name: '右脑',
                            type: 'line',
                            smooth: true,
                            symbol: 'none',
                            data: rightData,
                            itemStyle: {
                                normal: {
                                    color: '#844add', // 折线点的颜色
                                    lineStyle: {
                                        color: '#844add' // 折线颜色
                                    }
                                }
                            },
                        },
                    ]
                };
                this.rightNaoboCharts.setOption(option);
                window.addEventListener("resize", () => {
                    this.rightNaoboCharts.resize();
                });
            },

            // 左/右脑 - 平均值
            async __showCerebrum(data) {
                const leftValue = Math.round(data.left_cerebrum);
                const rigthValue = Math.round(data.rigth_cerebrum);
                if (leftValue > 50) {
                    this.leftCerebrum = "#ffff00";
                } else if (25 <= leftValue && leftValue <= 50) {
                    const colors = this.gradientColors("#ffff00", "#ff0000", 25);
                    this.leftCerebrum = colors[leftValue - 25];
                } else if (-25 <= leftValue && leftValue < 25) {
                    const colors = this.gradientColors("#ff0000", "#0000ff", 50);
                    this.leftCerebrum = colors[leftValue + 25];
                } else if (-50 <= leftValue && leftValue < -25) {
                    const colors = this.gradientColors("#0000ff", "#008000", 25);
                    this.leftCerebrum = colors[leftValue + 50];
                } else {
                    this.leftCerebrum = "#008000";
                }

                if (rigthValue > 50) {
                    this.rigthCerebrum = "#ffff00";
                } else if (25 <= rigthValue && rigthValue <= 50) {
                    const colors = this.gradientColors("#ffff00", "#ff0000", 25);
                    this.rigthCerebrum = colors[rigthValue - 25];
                } else if (-25 <= rigthValue && rigthValue < 25) {
                    const colors = this.gradientColors("#ff0000", "#0000ff", 50);
                    this.rigthCerebrum = colors[rigthValue + 25];
                } else if (-50 <= rigthValue && rigthValue < -25) {
                    const colors = this.gradientColors("#0000ff", "#008000", 25);
                    this.rigthCerebrum = colors[rigthValue + 50];
                } else {
                    this.rigthCerebrum = "#008000";
                }
            },
            gradientColors(start, end, steps, gamma) {
                let i, j, ms, me, output = [], so = [];
                gamma = gamma || 1;
                const normalize = (channel) => {
                    return Math.pow(channel / 255, gamma);
                };
                start = this.parseColor(start).map(normalize);
                end = this.parseColor(end).map(normalize);
                for (i = 0; i < steps; i++) {
                    ms = i / (steps - 1);
                    me = 1 - ms;
                    for (j = 0; j < 3; j++) {
                        so[j] = this.pad(Math.round(Math.pow(start[j] * me + end[j] * ms, 1 / gamma) * 255).toString(16));
                    }
                    output.push('#' + so.join(''));
                }
                return output;
            },
            parseColor(hexStr) {
                return hexStr.length === 4 ? hexStr.substr(1).split('').map(function (s) { return 0x11 * parseInt(s, 16); }) : [hexStr.substr(1, 2), hexStr.substr(3, 2), hexStr.substr(5, 2)].map(function (s) { return parseInt(s, 16); })
            },
            pad(s) {
                return (s.length === 1) ? '0' + s : s;
            },

            //  情绪
            async __naobo_zhishi_qingxu(data) {
                if (!data) return;
                if (!this.naobo_zhishi_qingxu) {
                    this.naobo_zhishi_qingxu = this.$echarts.init(document.getElementById('naobo_zhishi_qingxu'));
                }
                const emotionValue = parseInt(data.emotion);
                this.gaugePtion.series[0].data[0].name = "FAA"; // 情绪指数
                this.gaugePtion.series[0].data[0].value = emotionValue;
                this.gaugePtion.series[1].data[0].itemStyle.normal.color = "#00CC66";
                this.naobo_zhishi_qingxu.setOption(this.gaugePtion);
                window.addEventListener("resize", () => {
                    this.naobo_zhishi_qingxu.resize();
                });
            },
            // 认知
            async __naobo_zhishi_renzhi(data) {
                if (!data) return;
                if (!this.naobo_zhishi_renzhi) {
                    this.naobo_zhishi_renzhi = this.$echarts.init(document.getElementById('naobo_zhishi_renzhi'));
                }
                const cognitionValue = parseInt(data.cognition);
                this.gaugePtion.series[0].data[0].name = "ABR"; // 认知指数
                this.gaugePtion.series[0].data[0].value = cognitionValue;
                this.gaugePtion.series[1].data[0].itemStyle.normal.color = "#0099FF";
                this.naobo_zhishi_renzhi.setOption(this.gaugePtion);
                window.addEventListener("resize", () => {
                    this.naobo_zhishi_renzhi.resize();
                });
            },
            // 注意
            async __naobo_zhishi_zhuyi(data) {
                if (!data) return;
                if (!this.naobo_zhishi_zhuyi) {
                    this.naobo_zhishi_zhuyi = this.$echarts.init(document.getElementById('naobo_zhishi_zhuyi'));
                }
                const focusValue = parseInt(data.focus);
                this.gaugePtion.series[0].data[0].name = "TBR"; // 注意指数
                this.gaugePtion.series[0].data[0].value = focusValue;
                this.gaugePtion.series[1].data[0].itemStyle.normal.color = "#FF9999";
                this.naobo_zhishi_zhuyi.setOption(this.gaugePtion);
                window.addEventListener("resize", () => {
                    this.naobo_zhishi_zhuyi.resize();
                });
            },

            // 功率
            async __showPowerSpectrum(data) {
                const psdDatas = data["psds"];
                if (this.powerSpectrumDatas.length == 2) {
                    this.powerSpectrumDatas[0]["delta"] = Math.round(psdDatas[0]);
                    this.powerSpectrumDatas[0]["theta"] = Math.round(psdDatas[1]);
                    this.powerSpectrumDatas[0]["alpha"] = Math.round(psdDatas[2]);
                    this.powerSpectrumDatas[0]["beta"] = Math.round(psdDatas[3]);

                    this.powerSpectrumDatas[1]["delta"] = Math.round(psdDatas[4]);
                    this.powerSpectrumDatas[1]["theta"] = Math.round(psdDatas[5]);
                    this.powerSpectrumDatas[1]["alpha"] = Math.round(psdDatas[6]);
                    this.powerSpectrumDatas[1]["beta"] = Math.round(psdDatas[7]);
                } else {
                    const leftData = {
                        "name": "Left",
                        "delta": Math.round(psdDatas[0]),
                        "theta": Math.round(psdDatas[1]),
                        "alpha": Math.round(psdDatas[2]),
                        "beta": Math.round(psdDatas[3])
                    };
                    const rightData = {
                        "name": "Rigth",
                        "delta": Math.round(psdDatas[4]),
                        "theta": Math.round(psdDatas[5]),
                        "alpha": Math.round(psdDatas[6]),
                        "beta": Math.round(psdDatas[7])
                    };
                    this.powerSpectrumDatas.push(leftData);
                    this.powerSpectrumDatas.push(rightData);
                }
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/user/details.vue